// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2PFc-","fileBtn":"File_fileBtn__3kaqq","closeBtn":"File_closeBtn__1xcOW","fileSelected":"File_fileSelected__1tvwK","disabled":"File_disabled__2LtEB"};